import { Component, OnInit } from '@angular/core';

import { DocumentTemplateRole } from '../../../models/document-template-role';
import { DocumentTemplateRoleName } from '../../../models/document-template-role-name';

import { DocumentTemplateRoleNameService } from '../../../services/documents/document-template-role-name.service';
import { NotyService } from '../../../services/common/noty.service';

declare var swal: any;

@Component({
  selector: 'app-document-template-role-name-index',
  templateUrl: './document-template-role-name-index.component.html',
  styleUrls: ['./document-template-role-name-index.component.scss'],
})
export class DocumentTemplateRoleNameIndexComponent implements OnInit {
  addingNewDocumentTemplateRoleName: boolean = false;

  addingNewDocumentTemplateRole: boolean = false;

  loading: boolean = true;

  loadingTemplates: boolean = false;

  deletingDocumentTemplateRoleName: boolean = false;

  deletingDocumentTemplateRole: boolean = false;

  documentTemplateRoleNames: Array<DocumentTemplateRoleName> = [];

  documentTemplateRoles: Array<DocumentTemplateRole>;

  newDocumentTemplateRoleName: DocumentTemplateRoleName = new DocumentTemplateRoleName();

  newDocumentTemplateRole: DocumentTemplateRole = new DocumentTemplateRole();

  savingDocumentTemplateRole: boolean = false;
  savingDocumentTemplateRoleName: boolean = false;

  selectedDocumentTemplateRoleName: DocumentTemplateRoleName;

  constructor(private documentTemplateRoleNameService: DocumentTemplateRoleNameService, private notyService: NotyService) {}

  // Component lige cycle methods
  ngOnInit() {
    this.loadDocumentTemplateRoleNames();
  }

  // Component methods
  deleteDocumentTemplateRoleName(documentTemplateRoleName: DocumentTemplateRoleName) {
    swal({
      title: 'Delete Role',
      text: `Delete - ${documentTemplateRoleName.name} ?`,
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancel: {
          text: 'No',
          value: false,
          visible: true,
          className: '',
          closeModal: true,
        },
        confirm: {
          text: 'Yes',
          value: true,
          visible: true,
          className: '',
          closeModal: true,
        },
      },
    })
      .then((confirmed: any) => {
        if (confirmed) {
          this.deletingDocumentTemplateRoleName = true;
          this.documentTemplateRoleNameService
            .delete(documentTemplateRoleName.id)
            .then((response) => {
              this.deletingDocumentTemplateRoleName = false;
              if (response.success) {
                this.notyService.notify(response.text || `Deleted role - ${documentTemplateRoleName.name}`, 'warning');
                this.loadDocumentTemplateRoleNames();
              } else {
                this.notyService.notify(response.text || 'Error deleting role', 'error');
              }
            })
            .catch(() => {
              this.deletingDocumentTemplateRoleName = false;
              this.notyService.notify('Error deleting role', 'error');
            });
        }
      })
      .catch((err: any) => {
        console.log('Delete prompt error', err);
      });
  }

  deleteDocumentTemplateRole(documentTemplateRole: DocumentTemplateRole) {
    swal({
      title: 'Remove Template',
      text: `Remove template ${documentTemplateRole.template_name} from role ${this.selectedDocumentTemplateRoleName.name} ?`,
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancel: {
          text: 'No',
          value: false,
          visible: true,
          className: '',
          closeModal: true,
        },
        confirm: {
          text: 'Yes',
          value: true,
          visible: true,
          className: '',
          closeModal: true,
        },
      },
    })
      .then((confirmed: any) => {
        if (confirmed) {
          this.deletingDocumentTemplateRole = true;
          this.documentTemplateRoleNameService
            .removeDocumentTemplateRole(documentTemplateRole)
            .then((response) => {
              this.deletingDocumentTemplateRole = false;
              if (response.success) {
                this.notyService.notify(response.text || `Removed template ${documentTemplateRole.template_name} from role ${this.selectedDocumentTemplateRoleName.name}`, 'warning');
                this.loadTemplates();
              } else {
                this.notyService.notify(response.text || 'Error removing template', 'error');
              }
            })
            .catch(() => {
              this.deletingDocumentTemplateRole = false;
              this.notyService.notify('Error removing template', 'error');
            });
        }
      })
      .catch((err: any) => {
        console.log('Delete prompt error', err);
      });
  }

  loadDocumentTemplateRoleNames() {
    this.loading = true;
    this.documentTemplateRoleNameService.index().then((response_json) => {
      this.loading = false;
      this.documentTemplateRoleNames = response_json.document_template_role_names;
    });
  }

  loadTemplates() {
    this.loadingTemplates = true;
    this.documentTemplateRoleNameService.templates(this.selectedDocumentTemplateRoleName.id).then((response_json) => {
      this.loadingTemplates = false;
      this.documentTemplateRoles = response_json.document_template_roles;
    });
  }

  saveDocumentTemplateRole(documentTemplateRole: DocumentTemplateRole) {
    if (!documentTemplateRole.document_template_id) {
      this.notyService.notify('Template needs to be selected for the role, if already selected, please clear and try again', 'error');
      return;
    }
    this.savingDocumentTemplateRole = true;
    this.documentTemplateRoleNameService
      .saveDocumentTemplateRole(documentTemplateRole)
      .then((response_json) => {
        this.savingDocumentTemplateRole = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Template saved  to role', 'success');
          this.loadTemplates();
          this.newDocumentTemplateRole = new DocumentTemplateRole();
          this.newDocumentTemplateRole.document_template_role_name_id = this.selectedDocumentTemplateRoleName.id;
          this.addingNewDocumentTemplateRole = false;
        } else this.notyService.notify(response_json.text || 'Error saving template to role', 'error');
      })
      .catch(() => {
        this.savingDocumentTemplateRole = false;
        this.notyService.notify('Error saving template to role', 'error');
      });
  }

  saveDocumentTemplateRoleName(documentTemplateRoleName: DocumentTemplateRoleName) {
    if (!documentTemplateRoleName.name) {
      this.notyService.notify('Name needs to be filled for the role', 'error');
      return;
    }
    this.savingDocumentTemplateRoleName = true;
    this.documentTemplateRoleNameService
      .save(documentTemplateRoleName)
      .then((response_json) => {
        this.savingDocumentTemplateRoleName = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Document Template Role saved', 'success');
          if (documentTemplateRoleName.id) documentTemplateRoleName.editing = false;
          else {
            this.loadDocumentTemplateRoleNames();
            this.newDocumentTemplateRoleName = new DocumentTemplateRoleName();
            this.addingNewDocumentTemplateRoleName = false;
          }
        } else this.notyService.notify(response_json.text || 'Error saving document template role', 'error');
      })
      .catch(() => {
        this.savingDocumentTemplateRoleName = false;
        this.notyService.notify('Error saving document template role', 'error');
      });
  }

  selectDocTemplate(docTemplate: any) {
    if (docTemplate.model == 'document_template') {
      this.notyService.notify('This is a v1 template, only v5 templates are allowed', 'error');
      return;
    }
    this.newDocumentTemplateRole.document_template_id = docTemplate.id;
  }

  selectDocumentTemplateRoleName(documentTemplateRoleName: DocumentTemplateRoleName) {
    this.selectedDocumentTemplateRoleName = documentTemplateRoleName;
    this.newDocumentTemplateRole = new DocumentTemplateRole();
    this.newDocumentTemplateRole.document_template_role_name_id = this.selectedDocumentTemplateRoleName.id;
    this.loadTemplates();
  }
}
